import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'FeaturedArticle',
})(({ spacing, brandColors, aspectRatio, typography }) => ({
  wrapper: {
    borderBottom: `${typography.pxToRem(3)} solid ${brandColors.chargeBlue}`,
    paddingBottom: spacing(2),
  },
  imageWrapper: {
    display: 'block',
    aspectRatio: aspectRatio['16/9'],
    alignSelf: 'flex-start',
    width: '100%',
    overflow: 'hidden',
    borderRadius: typography.pxToRem(16),
    marginBottom: spacing(1),
  },
  image: {
    objectFit: 'cover',
    borderRadius: typography.pxToRem(16),
    aspectRatio: aspectRatio['16/9'],
    width: '100%',
    transition: 'transform 0.3s ease-in-out',

    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  title: {
    marginBottom: spacing(-1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    '& a': {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));

export default useStyles;
